import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryActive, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	panel: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 8,
		marginBottom: 20,
		marginRight: 20,
	},
	fab: {
		width: 48,
		height: 48,
		borderRadius: '50%',
		backgroundColor: brandPrimary,
		color: white,
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		boxShadow: '0 4px 12px rgba(99, 102, 241, 0.4)',
		transition: 'all 0.2s ease',
		':hover': {
			backgroundColor: brandPrimaryActive,
			transform: 'scale(1.1)',
			boxShadow: '0 6px 16px rgba(99, 102, 241, 0.5)',
		},
		':active': {
			transform: 'scale(0.95)',
		},
		':disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
			transform: 'none',
		},
		':focus': {
			outline: '3px solid rgba(99, 102, 241, 0.4)',
			outlineOffset: 2,
		},
	},
	fabLoading: {
		pointerEvents: 'none',
	},
	spinner: {
		width: 24,
		height: 24,
		animationName: {
			from: { transform: 'rotate(0deg)' },
			to: { transform: 'rotate(360deg)' },
		},
		animationDuration: '1s',
		animationIterationCount: 'infinite',
		animationTimingFunction: 'linear',
	},
	tooltip: {
		fontSize: 12,
		fontWeight: 500,
		color: '#6b7280',
		backgroundColor: white,
		padding: '4px 8px',
		borderRadius: 4,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
	},
});
